import wrapWithProvider from "./wrap-with-provider.js"
export const wrapRootElement = wrapWithProvider
